import { Component } from '@angular/core';
import { AppStateService } from '../../common/services/app-state/app-state.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserService } from '../../user/services/user.service';
import { INavigationItem } from '../types/inavigation-item';
import { SimpleConfirmDialogComponent } from '../../common/components/confirm-dialog/simple-confirm-dialog.component';
import { SimpleConfirmDialogConfig } from '../../common/interfaces/confirm-dialog-config/simple-confirm-dialog-config';
import { AuthenticationService } from '../../user/services/authentication.service';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from '../services/navigation.service';

@Component({
    selector: 'cas-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent {

    public userNavigations: INavigationItem[] = [
        {
            url: '/settings',
            name: 'Settings',
            icon: 'settings',
            isVisible: () => true,
        },
        {
            url: '',
            name: 'Logout',
            icon: 'logout',
            clickHandler: () => this.logout(),
            isVisible: () => true,
        }
    ];

    constructor(
        private authenticationService: AuthenticationService,
        public userService: UserService,
        private appStateService: AppStateService,
        public deviceService: DeviceDetectorService,
        private matDialogService: MatDialog,
        public navigationService: NavigationService
    ) {
    }

    public logout() {
        const data: SimpleConfirmDialogConfig = {
            confirmButton: 'Logout',
            dismissButton: 'Cancel',
            icon: 'warning',
            message: 'Do you want to sign out of CASLink?',
            title: 'Logout'
        };

        const dialogRef = this.matDialogService
            .open(SimpleConfirmDialogComponent, {data, panelClass: 'paddingless-dialog'});

        dialogRef
            .afterClosed()
            .subscribe((result: boolean) => {
                if (result) {
                    this.authenticationService.logout();
                }
            });
    }

    public navigate(navigation: INavigationItem) {
        this.back();

        this.navigationService.navigate(navigation);
    }

    public isDesktop() {
        return this.appStateService.isDesktop;
    }

    public closeMenu() {
        this.appStateService.isSideNavOpened = false;
    }

    public back() {
        if (!this.isDesktop()) {
            this.appStateService.isSideNavOpened = false;
        }
    }

    public trackByName(index: number, item: INavigationItem) {
        return item.name;
    }

    public isUsernameLong(): boolean {
        return this.userService.claims && this.userService.claims.name && this.userService.claims.name.length > 23;
    }

    public getName() {
        return this.userService.claims && this.userService.claims.name;
    }
}
